import i18n, { use } from 'i18next'
import { initReactI18next } from 'react-i18next'
import englishLocalization from '../translations/en'

const devEnvironment = process.env.NODE_ENV === 'development'

use(initReactI18next).init({
    interpolation: { escapeValue: false },
    fallbackLng: 'en',
    preload: ['en'],
    initImmediate: true,
    react: {
        useSuspense: false
    },
    debug: devEnvironment,
    resources: {
        en: englishLocalization
    }
})

export default i18n
